// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"928":"181f01b9","9501":"92089ed3"}[chunkId] + ".chunk.css";
};